import { render, staticRenderFns } from "./shanxing.vue?vue&type=template&id=1d1fe020&scoped=true&"
import script from "./shanxing.vue?vue&type=script&lang=js&"
export * from "./shanxing.vue?vue&type=script&lang=js&"
import style0 from "./shanxing.vue?vue&type=style&index=0&id=1d1fe020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1fe020",
  null
  
)

export default component.exports